export const SET_CLIENT_ADD_FRIEND_FORM_DATA = 'SET_CLIENT_ADD_FRIEND_FORM_DATA'
export const EMPTY_CLIENT_ADD_FRIEND_FORM_DATA = 'EMPTY_CLIENT_ADD_FRIEND_FORM_DATA'
